/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Override_Usage_HintInputs */



/**
* | output |
* | --- |
* | "Use Override for a judge ruling on a disputed or abandoned table. For a wrong number, fix the VPs instead." |
*
* @param {Override_Usage_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const override_usage_hint = /** @type {((inputs?: Override_Usage_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Override_Usage_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisez Modifier pour une décision de juge sur une table contestée ou abandonnée. Pour un chiffre erroné, corrigez plutôt les VP.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Use Anular para una decisión del juez en una mesa disputada o abandonada. Para un número erróneo, corrija los VP.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Use Substituir para uma decisão de juiz em mesa contestada ou abandonada. Para um número errado, corrija os VP.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Usa Sovrascrivi per una decisione del giudice su un tavolo contestato o abbandonato. Per un numero sbagliato, correggi i VP.")
	return /** @type {LocalizedString} */ ("Use Override for a judge ruling on a disputed or abandoned table. For a wrong number, fix the VPs instead.")
});